export const title1 = 'Computational Psychiatry Research Map​'
export const subtitle1 =
  'The Computational Psychiatry Research Map (CPSYMAP) is a tool for visualizing research papers from computational psychiatry as a two-dimensional "map". Using this map, explore the distribution of papers along neuroscientific, psychiatric and computational dimensions.'
export const title2 = 'We need your help​'
export const subtitle2 =
  'CPSYMAP is a community-driven effort to enrich computational psychiatry. Add a new paper or tag an existing one and help improve the visibility of research results in this field.'
export const title3 = 'Papers lately added to CPSYMAP​​'
export const title4 = 'Citing CPSYMAP'
export const subtitle4 = 'To cite CPSYMAP in your work, please include one or several of references. '
